import Button from 'src/components/Button';

const containerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px 10px 20px',
    gap: '5px',
    height: '52px',
};

function CustomMenuFooter({
    onClearAll,
    onApply,
    forceClose,
}: {
    onClearAll: () => void;
    onApply: () => void;
    forceClose?: () => void;
}) {
    return (
        <div style={containerStyle}>
            <Button
                sx={{ width: '88px', borderRadius: `8px`, borderColor: '#E5E5E5' }}
                variant="outlined-black"
                onClick={() => {
                    onClearAll();
                    forceClose?.();
                }}
            >
                Clear All
            </Button>
            <Button
                onClick={() => {
                    onApply();
                    forceClose?.();
                }}
            >
                Apply
            </Button>
        </div>
    );
}

export default CustomMenuFooter;
